<template>
  <div class="rating" :class="[`rating--${size}`, { 'rating--box': box }]">
    <span v-if="prefix" class="prefix">{{ prefix }}</span>
    <span
        v-for="(rate, index) in new Array(5)"
        :key="index"
        class="rating__item"
        :class="{ 'rating__item--rated': rating >= index + 1, 'rating__item--box': box }"
    >
          <span
              class="rating__item__skeleton"
              :style="`width: ${Math.round(Math.min(100, Math.max(0, (rating - index) * 100)))}%`"
          >
          </span>
    </span>

    <div v-if="totalText || total" class="rating__item__total" :class="{ 'rating__item__total--box': box }">
      <template v-if="totalText"> {{ totalText }} ({{ $numberFormat(total) }}) </template>
      <template v-else-if="total > 0"> {{ $numberFormat(rating) }} / {{ $numberFormat(total) }}x </template>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: null,
    },
    totalText: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'size-s',
    },
    box: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.rating {
  display: inline-flex;
  gap: 2px;
  justify-content: space-between;

  .prefix {
    font-size: 12px;
    margin-right: 5px;
  }

  &--box {
    background-color: #fff4e0;
    border-radius: 26px;
    padding: 6px 12px;
  }

  &--size-s {
    .rating__item {
      width: 12px;
      height: 12px;
      background-size: 12px 12px;
    }

    .rating__item__skeleton {
      height: 12px;
      background-size: 12px 12px;
    }
  }

  &--size-l {
    .rating__item {
      width: 14px;
      height: 14px;
      background-size: 14px 14px;
    }

    .rating__item__skeleton {
      height: 14px;
      background-size: 14px 14px;
    }
  }

  &--size-xl {
    .rating__item {
      width: 16px;
      height: 16px;
      background-size: 16px 16px;
      margin-right: 2px;
    }

    .rating__item__skeleton {
      height: 16px;
      background-size: 16px 16px;
    }

    .rating__item__total {
      font-size: 14px;
      height: 16px;
      line-height: 16px;
    }
  }
}

.rating__item {
  background: url('https://www.pilulka.cz/nuxt-assets/images/icons/star-deactivate-silver.svg') no-repeat 0 0;

  &--box {
    background-image: url('https://www.pilulka.cz/nuxt-assets/images/icons/star-deactivate.svg');
  }

  &--rated {
    background-image: url('https://www.pilulka.cz/nuxt-assets/images/icons/star-activate.svg');
  }
}

.rating__item__skeleton {
  height: 100%;
  display: block;
  background: url('https://www.pilulka.cz/nuxt-assets/images/icons/star-activate.svg') no-repeat 0 0;
}

.rating__item__total {
  color: #333333;
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  margin-left: 3px;
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
